// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"flip-to-back"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 8.5V20H15.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9.5 16H8V14.5M13.5 16H14.5M18.5 4H20V5.5M20 9.5V10.5M18.5 16H20V14.5M8 9.5V10.5M9.5 4H8V5.5M13.5 4H14.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FlipToBackIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'flip-to-back',
    ref,
    icon: element,
  },
));

FlipToBackIcon.displayName = 'FlipToBackIcon';

export default FlipToBackIcon;
